<template>
  <v-card
      :dark="selectedAddons.indexOf(addon) !== -1"
      :color="selectedAddons.indexOf(addon) !== -1 ? 'primary':'white'"
      elevation="1"
      @click="OnAddonSelect(addon)"
      class="ma-2 AddonCard"
      v-bind:class="{
        'ActiveBorder':selectedAddons.indexOf(addon) !== -1,
        'Border':selectedAddons.indexOf(addon) === -1,
      }"
      height="260" width="300" ripple hover>
        <div style="background: #E5E5E5" class="pa-8">
          <v-chip v-if="selectedAddons.indexOf(addon) !== -1" color="#07614D" outlined style="position: absolute;top: 12px;right: 12px; background-color: #ffff !important;">{{ selectedAddons.indexOf(addon)+1 }}</v-chip>
          <v-img v-if="addon.image_url === ''" height="96" class="rounded-sm" contain src="assets/addon.png" >

          </v-img>
        </div>
        <v-img v-if="addon.image_url !== ''" height="160" class="rounded-sm " :src="addon.image_url" >
          <v-chip v-if="selectedAddons.indexOf(addon) !== -1" color="#07614D" outlined style="position: absolute;top: 12px;right: 12px;">{{ selectedAddons.indexOf(addon)+1 }}</v-chip>

        </v-img>
        <!-- <v-row v-if="selectedAddons.indexOf(addon) !== -1" no-gutters justify="center" class="SmallFont">
          You Have Selected
        </v-row> -->
      <v-card-title class="pt-0 pb-0 ma-0 text-center">
            <v-row no-gutters justify="center">
              <span style="word-break: break-word; line-height: 24px;" class="MedFont font-weight-bold mt-2">{{ addon.name }}
                <!--<v-icon color="#D6AF44" size="21" v-if="selectedAddons.indexOf(addon) !== -1">mdi-check</v-icon>-->
            </span>
            </v-row>
      </v-card-title>
    <!--<v-row no-gutters>

      <v-col cols="12" sm="12" md="8" lg="8" xl="8" style="height: 180px !important;">

        <v-card-text style="text-overflow: ellipsis !important; white-space: nowrap;
        overflow: hidden;" class="pb-1 text-start">
          <span>{{ addon.details }}</span>
        </v-card-text>
        <v-card-actions class="pl-4 pr-4">
          <span class="font-weight-bold SmallFont">{{ MoneyFormat(addon.price) }}
            <span v-if="addon.type === 0" class="font-weight-thin font-italic MuchSmallFont">Per Person</span>
            <span v-if="addon.type === 1" class="font-weight-thin font-italic MuchSmallFont">Per Package</span>
          </span>
        </v-card-actions>
      </v-col>

      <v-col cols="4" class="pa-0 ma-0 hidden-sm-and-down">

      </v-col>
    </v-row>
    -->
  </v-card>
</template>

<script>
export default {
  name: "AddonCard",
  props:{
    selectedAddons: Array,
    addon: Object,
    index: Number,
  },
  methods:{
    MoneyFormat(value){
      return Intl.NumberFormat('en-US', { style: 'currency', currency: 'LKR' }).format(value);
    },
    OnAddonSelect(addon){
      this.$emit('OnAddonSelect',addon)
    },

  },
  mounted() {
    console.log(this.addon.image_url);
  }
}
</script>

<style scoped>
.AddonCard{
  cursor: pointer;
  transition: 256ms;
}
.MedFont{
  font-size: 1.1rem;
}

.SmallFont{
  font-size: 14px;
}

.MuchSmallFont {
  font-size: 14px;
}

.Border{
  border: 2px solid #85BBC4  !important;
}

.ActiveBorder{
  border: 2px solid #D6AF44  !important;
}

.v-card .ActiveBorder {
  border: 2px solid #D6AF44 !important
}

.v-card {
  border: 2px solid #85BBC4 !important
}
</style>
